import cron from "node-cron";
import { db } from "@workspace/db";
import { tendersTable, usersTable, companiesTable, notificationSettingsTable } from "@workspace/db";
import { eq, and, gte, lte } from "drizzle-orm";
import { sendMail, deadlineReminderHtml } from "./mailer";
import { logger } from "./logger";

export function startDeadlineReminderCron(): void {
  cron.schedule("0 8 * * *", async () => {
    logger.info("Running deadline reminder cron job");
    try {
      const now = new Date();

      for (const daysLeft of [7, 1]) {
        const targetDate = new Date(now);
        targetDate.setDate(targetDate.getDate() + daysLeft);
        const dayStart = new Date(targetDate);
        dayStart.setHours(0, 0, 0, 0);
        const dayEnd = new Date(targetDate);
        dayEnd.setHours(23, 59, 59, 999);

        const tenders = await db
          .select({
            tender: tendersTable,
            company: companiesTable,
          })
          .from(tendersTable)
          .innerJoin(companiesTable, eq(tendersTable.companyId, companiesTable.id))
          .where(
            and(
              gte(tendersTable.deadline, dayStart),
              lte(tendersTable.deadline, dayEnd),
            ),
          );

        for (const { tender, company } of tenders) {
          const notifRow = await db
            .select()
            .from(notificationSettingsTable)
            .where(eq(notificationSettingsTable.companyId, company.id))
            .limit(1);

          const notif = notifRow[0];
          const enabled = daysLeft === 7
            ? (notif?.deadlineReminder7Days ?? true)
            : (notif?.deadlineReminder1Day ?? true);

          if (!enabled) continue;

          const users = await db
            .select()
            .from(usersTable)
            .where(eq(usersTable.companyId, company.id));

          for (const user of users) {
            if (!user.email) continue;
            const isAr = user.language === "ar";
            const firstName = user.firstName ?? (isAr ? "المستخدم" : "there");
            const subject = isAr
              ? `تذكير: ${tender.title} – ${daysLeft} أيام متبقية`
              : `Reminder: ${tender.title} – ${daysLeft} day(s) left`;

            await sendMail({
              to: user.email,
              subject,
              html: deadlineReminderHtml(firstName, tender.title, tender.deadline!, daysLeft, isAr),
            });
          }
        }
      }
    } catch (err) {
      logger.error({ err }, "Deadline reminder cron failed");
    }
  }, { timezone: "Asia/Riyadh" });

  logger.info("Deadline reminder cron scheduled (daily 08:00 AST)");
}
